var map = {
	"./cash-icon-home-mobile.webp": 1630,
	"./cashout-icon-home-mobile.webp": 1631,
	"./transfer-icon-home-mobile.webp": 1632,
	"./vip-icon-home-mobile-active.webp": 1633,
	"./vip-icon-home-mobile.webp": 1634,
	"./wallet-icon-home-mobile.webp": 1635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;